import { linkHandler } from 'utils/linkHandler';

const getInitialState = () => ({
  isAuthed: false,
  confirmedSubscription: {
    isGiftCoupon: false,
    confirmedPurchase: false,
    autoAssigned: false
  },
  cancellationRequestData: {
    receivedDate: null,
    email: null,
    confirmationPdfUrl: null
  },
  token: null,
  currentUser: null,
  paymentMethodAutoAssigned: false,
  hasSubscription: false,
  isFetching: false,
  zppAlreadyApplied: false,
  isGuest: true,
  isGoogleUser: false,
  isLoginError: false,
  unconfirmedEmail: '',
  refererAfterAuthenticateUrl: linkHandler.get('profilePersonalData'),
  openRequests: [],
  failedRequests: [],
  succeededCooperationForm: null,
  updatedAt: 0,
  error: null
});

export default {
  getInitialState
};
